import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { ModuleName } from 'src/app/middleware/common/Enum/common.enum';
import { AddEmailActionComponent } from 'src/app/middleware/common/addEmailAction/addEmailAction.component';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import * as jwt_decode from 'jwt-decode';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { AddCustomInfoComponent } from 'src/app/middleware/common/addCustomInfo/addCustomInfo.component';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  selector: 'app-customInfo3c',
  templateUrl: './customInfo3c.component.html',
  styleUrls: ['./customInfo3c.component.scss']
})
export class CustomInfo3cComponent implements OnInit {
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;
  OfficeIDList: any=[];
  myOfficeID: any;

  @Input() mainModulename: string; 
  getTagListResponseHolder: any;
 
  AllCustomInfoList:any[]=[];
  AllCustomInfoListShow:boolean=false;
  CustomInfoTypeForFilter:any[]=[];
  CustomInfoType :any[]=[];

  constructor(private dialog: MatDialog,private taskService: SettingService,
    private statusConst: StatusConstant, private encryptionAlgo: EncryptionService,
    private reusableClass: ReusableClasses,private loaderService: LoaderService,
    private toastr: ToastrService,private sanitizer: DomSanitizer) {
      const encryptedtoken = sessionStorage.getItem('userToken');
      this.databaseId = sessionStorage.getItem('databaseId');
      this.organizationId = sessionStorage.getItem('organizationID');
      const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey,encryptedtoken);   
      this.currentUser = jwt_decode(token); 
      var offices=JSON.parse(sessionStorage.getItem('officeList'));
      offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if(oe.isMyoffice==true)
        this.myOfficeID=oe.officeID;
      }); 
   }

  ngOnInit(): void {
    this.mainModulename;
    this.GetAllCustomInfos();
  }

  
 // get Get AllCustom Info list
 GetAllCustomInfos() {
  var cType=0;
  if(this.mainModulename=="Core"){
    cType=1;
  }
  if(this.mainModulename=="Contact"){
    cType=2;
  }
  if(this.mainModulename=="Company"){
    cType=3;
  }
  var ReqModel={
    cType:cType,
    transactionID:Number(sessionStorage.getItem('transactionID')),     
    customNotesType:0,
    userID:this.currentUser.UID,
    organizationID:Number(this.organizationId),
    officeID: this.myOfficeID,
    databaseId:Number(this.databaseId)      
   }
   this.loaderService.show();
   this.taskService.getAllCustomInfos(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.getTagListResponseHolder = response;
      this.loaderService.hide();
      if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {        
        this.getTagListResponseHolder = response.data;
        if(this.getTagListResponseHolder!=null){
          this.getTagListResponseHolder.map((res) => {
            if (res.createdByLastName != null) {
              res.createdByFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.createdByFirstName);
            }
            if (res.createdByLastName != null) {
              res.createdByLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.createdByLastName);
            }
            if (res.customNote != null) {
              res.customNote1=  res.customNote.replace(/\n\n/g, '<br><br>').replace(/\n/g, '<br>');
              res.customNoteNew = this.makeLinksClickable(res.customNote1);             
            }
            return res;
          });
        }          
        this.AllCustomInfoList = this.getTagListResponseHolder; 
        if(this.AllCustomInfoList!=null){
          this.AllCustomInfoListShow=true;              
        }else{
          this.AllCustomInfoListShow=false;
        }    
        this.getCustomInfoTypeList();  
      }
      else {
        this.AllCustomInfoList=[];
        this.loaderService.hide();    
      }
    }else{
      this.AllCustomInfoList=[];
      this.loaderService.hide();
    }
  });
}
 
makeLinksClickable(text: string): SafeHtml {
  if (!text) {
    return this.sanitizer.bypassSecurityTrustHtml('');
  }

  // Regular expression to match URLs
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  // Replace URLs with anchor tags
  const modifiedText = text.replace(urlRegex, '<a href="$1" target="_blank" rel="noopener noreferrer">$1</a>');

  // Sanitize the resulting HTML
  return this.sanitizer.bypassSecurityTrustHtml(modifiedText);
}

  addCustomInfo() {
    const dialogRef = this.dialog.open(AddCustomInfoComponent, {     
      panelClass: 'custom-modalbox',
      data: {
        moduleName:this.mainModulename,
        folderID:1,//this.folderId, {{Main=1;Item=2;}}
        documentID: null
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=null && result!=undefined){
        this.GetAllCustomInfos();
      }      
    });
  } 
     
  onChangeSelectedType(customInfoTypeID) {
    var cType=0;
    if(this.mainModulename=="Core"){
      cType=1;
    }
    if(this.mainModulename=="Contact"){
      cType=2;
    }
    if(this.mainModulename=="Company"){
      cType=3;
    }
    if(customInfoTypeID.value == 0){
      this.GetAllCustomInfos();
    }
    else {
    var ReqModel={
      cType:cType,
      transactionID:Number(sessionStorage.getItem('transactionID')),     
      customNotesType:Number(customInfoTypeID.value),
      userID:this.currentUser.UID,
      organizationID:Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseId:Number(this.databaseId) 
    }
    this.loaderService.show();
   this.taskService.getAllCustomInfos(ReqModel).subscribe(response => {
    if (response != undefined) {
      this.getTagListResponseHolder = response;
      this.loaderService.hide();
      if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {        
        this.getTagListResponseHolder = response.data;
        if(this.getTagListResponseHolder!=null){
          this.getTagListResponseHolder.map((res) => {
            if (res.createdByLastName != null) {
              res.createdByFirstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.createdByFirstName);
            }
            if (res.createdByLastName != null) {
              res.createdByLastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey,res.createdByLastName);
            }            
            return res;
          });
        }          
        this.AllCustomInfoList = this.getTagListResponseHolder; 
        if(this.AllCustomInfoList!=null){
          this.AllCustomInfoListShow=true;              
        }else{
          this.AllCustomInfoListShow=false;            
        }   
        this.getCustomInfoTypeList();     
      }
      else {
        this.AllCustomInfoList=[];
        this.loaderService.hide();    
      }
    }else{
      this.AllCustomInfoList=[];
      this.loaderService.hide();
    }
  });
   }
  }

  editCustomInfo(customInfo:any){
    const dialogRef = this.dialog.open(AddCustomInfoComponent, {     
      panelClass: 'custom-modalbox',
      data: {
        moduleName:this.mainModulename,
        folderID:1,//this.folderId, {{Main=1;Item=2;}}
        documentID: null,
        customInfo:customInfo
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if(result!=null && result!=undefined){
        this.GetAllCustomInfos();
      }      
    });
  }

  deleteCustomInfo(customInfo:any){   
    const message = `Are you sure you want to delete this custom info ?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      try {
        if (dialogResult) {
          var cType=0;
          if(this.mainModulename=="Core"){
            cType=1;
          }
          if(this.mainModulename=="Contact"){
            cType=2;
          }
          if(this.mainModulename=="Company"){
            cType=3;
          }
          let model={
              customNotesID: [customInfo.customNoteID],
              cType: cType,
              transactionID:Number(sessionStorage.getItem('transactionID')),
              databaseId:Number(this.databaseId),
              organizationID:Number(this.organizationId),
              userID:this.currentUser.UID,
              officeID: this.myOfficeID
          }
          this.taskService.deleteCustomInfo(model).subscribe(response => {
            if (response != undefined) {
              if (response.status == this.statusConst.statusSuccess) {                 
                this.toastr.success("Custom info Deleted successfully.", '', {
                  timeOut: 3000,
                });  
                this.GetAllCustomInfos();
              }
              else {
               
              }
            }
          });
        }
      } catch (e) {
        //Observable.throw(e);
      }
    });     
  }

  // get custom type ==//
 getCustomInfoTypeList() {
  this.CustomInfoType=[];      
  this.CustomInfoTypeForFilter=[];  
  var ReqModel={
    databaseId:Number(this.databaseId),
    organizationID:Number(this.organizationId),
    officeID: this.myOfficeID,
    userID:this.currentUser.UID,
   }
   this.taskService.getCustomInfoTypes(ReqModel).subscribe(response => {
     if (response != undefined) {
       this.getTagListResponseHolder = response;
       if (this.getTagListResponseHolder.status == this.statusConst.statusSuccess) {         
          this.CustomInfoType = this.getTagListResponseHolder.data;
 
         var newlist =[];
         var ReqModel1 ={         
            customInfoTypeID: 0,
            customInfoName: "All"
         }
         this.CustomInfoTypeForFilter.push(ReqModel1);
         newlist = this.getTagListResponseHolder.data;
          if(newlist==null){
           newlist=[];
          }
         for (var i = 0, len = newlist.length; i < len; ++i) {
           this.CustomInfoTypeForFilter.push(newlist[i]);
        }   
       }
       else {      
       }
     }
   });
 }
   
}
